export default {
    en: {
        forms: {
            commonFormElements: {
                generate: "Generate",
                cancel: "Cancel",
                confirm: "Confirm",
                close: "Close",
                create: "Create",
            },
            energyConfirmation: {
                requires: "Requires {energyCost} ENERGY. Remaining {currentEnergy}. Checkout subscriptions options for additional energy.",
                willConsume: "Will consume {energyCost} of {currentEnergy} energy.",
                close: "Close",
                cancel: "Cancel",
                confirm: "Confirm"
            },
            optionsMenu: {
                metadata: "Metadata",
                fork: "Fork",
                foundryJson: "Foundry Json",
                shareWithParty: "Share with party",
                regenerateIllustration: "Regenerate Illustration",
                modifyContent: "Modify Content",
                deleteContent: "Delete",
                pushContent: "Push",
                statBlock: "Stat Block",
                removeBackground: "Remove Background",
            },
            creatureGenerator: {
                title: "Generate Creature",
                descriptionPrompt: "Description (Be Creative)",
                artStyle: "Art Style",
                edition: "Edition",
                challengeRating: "Challenge Rating",
                waitTime: "Wait {time}s",  // Using a placeholder to keep it more general
                generate: "Generate",
                language: "Language",
                challengeRatingWithValue: "Challenge Rating {challengeRating}",
                placeholders: {
                    influence: "Describe the creature.",
                    edition: "Select an edition",
                    style: "Dark/Gritty",
                },
            },
            locationGenerator: {
                title: "Location",
                locationName: "Location Name",
                locationNamePlaceholder: "A name for the location",
                locationDescription: "Location Description",
                descriptionPlaceholder: "Describe the environment here",
            },
            styles: {
                darkFantasy: "Dark Fantasy",
                highFantasy: "High Fantasy",
                sketch: "Sketch",
                etherealDream: "Ethereal Dream",
                realism: "Realism",
                pixelArt: "Pixel Art",
                graphicNovel: "Graphic Novel",
                conceptArt: "Concept Art",
            }
        }
    },
    fr: {
        forms: {
            energyConfirmation: {
                requires: "Nécessite {energyCost} ÉNERGIE. Restant {currentEnergy}. Consultez les options d'abonnement pour obtenir de l'énergie supplémentaire.",
                willConsume: "Consommera {energyCost} sur {currentEnergy} énergie.",
                close: "Fermer",
                cancel: "Annuler",
                confirm: "Confirmer"
            },
            optionsMenu: {
                metadata: "Métadonnées",
                fork: "Dupliquer",
                foundryJson: "Foundry Json",
                shareWithParty: "Partager avec le groupe",
                regenerateIllustration: "Régénérer l'illustration",
                modifyContent: "Modifier le contenu",
                deleteContent: "Supprimer",
                statBlock: "Fiche Technique",
                removeBackground: "Supprimer l'arrière-plan",
            },
            creatureGenerator: {
                title: "Générer une Créature",
                descriptionPrompt: "Description (Soyez créatif)",
                artStyle: "Style d'art",
                edition: "Édition",
                challengeRating: "Niveau de Défi",
                challengeRatingWithValue: "Classement de Défi {challengeRating}",
                waitTime: "Attendez {time}s",
                generate: "Générer",
                language: 'Langue',
                placeholders: {
                    influence: "Décrivez la créature.",
                    edition: "Sélectionnez une édition",
                    style: "Sombre/Grain",
                },
            },
            styles: {
                darkFantasy: "Dark Fantasy",
                highFantasy: "High Fantasy",
                sketch: "Sketch",
                etherealDream: "Ethereal Dream"
            }
        }
    },
    es: {
        energyConfirmation: {
            requires: "Requiere {energyCost} ENERGÍA. Restante {currentEnergy}. Consulta las opciones de suscripción para obtener energía adicional.",
            willConsume: "Consumirá {energyCost} de {currentEnergy} energía.",
            close: "Cerrar",
            cancel: "Cancelar",
            confirm: "Confirmar"
        },
        optionsMenu: {
            metadata: "Metadatos",
            fork: "Bifurcar",
            foundryJson: "Foundry Json",
            shareWithParty: "Compartir con el grupo",
            regenerateIllustration: "Regenerar ilustración",
            modifyContent: "Modificar contenido",
            deleteContent: "Eliminar",
            statBlock: "Bloque de Estadísticas",
            removeBackground: "Eliminar Fondo",
        },
        forms: {
            creatureGenerator: {
                title: "Generar Criatura",
                descriptionPrompt: "Descripción (Sé Creativo)",
                artStyle: "Estilo de Arte",
                edition: "Edición",
                challengeRating: "Nivel de Desafío",
                challengeRatingWithValue: "Calificación de Desafío {challengeRating}",
                waitTime: "Espera {time}s",
                generate: "Generar",
                language: 'Idioma',
                placeholders: {
                    influence: "Describe la criatura.",
                    edition: "Selecciona una edición",
                    style: "Oscuro/Áspero",
                },
            },
            styles: {
                darkFantasy: "Fantasía Oscura",
                highFantasy: "Alta Fantasía",
                sketch: "Boceto",
                etherealDream: "Sueño Etéreo",
                realism: "Realismo",
                pixelArt: "Pixel Art",
                graphicNovel: "Novela Gráfica",
                conceptArt: "Arte Conceptual",
            }
        }
    },
    de: {
        forms: {
            energyConfirmation: {
                requires: "Benötigt {energyCost} ENERGIE. Verbleibend {currentEnergy}. Siehe Abonnementoptionen für zusätzliche Energie.",
                willConsume: "Wird {energyCost} von {currentEnergy} Energie verbrauchen.",
                close: "Schließen",
                cancel: "Abbrechen",
                confirm: "Bestätigen"
            },
            optionsMenu: {
                metadata: "Metadaten",
                fork: "Verzweigen",
                foundryJson: "Foundry Json",
                shareWithParty: "Mit der Gruppe teilen",
                regenerateIllustration: "Illustration regenerieren",
                modifyContent: "Inhalt ändern",
                deleteContent: "Löschen",
                statBlock: "Werteblock",
                removeBackground: "Hintergrund entfernen",
            },
            creatureGenerator: {
                title: "Kreatur Generieren",
                descriptionPrompt: "Beschreibung (Sei Kreativ)",
                artStyle: "Kunststil",
                edition: "Ausgabe",
                challengeRating: "Herausforderungsgrad",
                challengeRatingWithValue: "Herausforderungsgrad {challengeRating}",
                waitTime: "Warte {time}s",
                generate: "Generieren",
                language: 'Sprache',
                placeholders: {
                    influence: "Beschreibe die Kreatur.",
                    edition: "Wähle eine Ausgabe",
                    style: "Dunkel/Rau",
                },
            },
            styles: {
                darkFantasy: "Dunkle Fantasie",
                highFantasy: "Hohe Fantasie",
                sketch: "Skizze",
                etherealDream: "Ätherischer Traum",
                realism: "Realismus",
                pixelArt: "Pixel Kunst",
                graphicNovel: "Graphic Novel",
                conceptArt: "Konzeptkunst",
            }
        }
    },
    pt: {
        forms: {
            energyConfirmation: {
                requires: "Requer {energyCost} ENERGIA. Restante {currentEnergy}. Verifique as opções de assinatura para energia adicional.",
                willConsume: "Consumirá {energyCost} de {currentEnergy} energia.",
                close: "Fechar",
                cancel: "Cancelar",
                confirm: "Confirmar"
            },
            optionsMenu: {
                metadata: "Metadados",
                fork: "Bifurcar",
                foundryJson: "Foundry Json",
                shareWithParty: "Compartilhar com o grupo",
                regenerateIllustration: "Regenerar ilustração",
                modifyContent: "Modificar conteúdo",
                deleteContent: "Excluir",
                statBlock: "Bloco de Estatísticas",
                removeBackground: "Remover Fundo",
            },
            creatureGenerator: {
                title: "Gerar Criatura",
                descriptionPrompt: "Descrição (Seja Criativo)",
                artStyle: "Estilo de Arte",
                edition: "Edição",
                challengeRating: "Nível de Desafio",
                challengeRatingWithValue: "Classificação de Desafio {challengeRating}",
                waitTime: "Aguarde {time}s",
                generate: "Gerar",
                language: 'Língua',
                placeholders: {
                    influence: "Descreva a criatura.",
                    edition: "Selecione uma edição",
                    style: "Escuro/Áspero",
                },
            },
            styles: {
                darkFantasy: "Fantasia Sombria",
                highFantasy: "Alta Fantasia",
                sketch: "Esboço",
                etherealDream: "Sonho Etéreo",
                realism: "Realismo",
                pixelArt: "Pixel Art",
                graphicNovel: "Novela Gráfica",
                conceptArt: "Arte Conceitual",
            }
        }
    },
    it: {
        forms: {
            energyConfirmation: {
                requires: "Richiede {energyCost} ENERGIA. Rimasti {currentEnergy}. Controlla le opzioni di abbonamento per energia aggiuntiva.",
                willConsume: "Consumerà {energyCost} di {currentEnergy} energia.",
                close: "Chiudi",
                cancel: "Annulla",
                confirm: "Conferma"
            },
            optionsMenu: {
                metadata: "Metadati",
                fork: "Biforca",
                foundryJson: "Foundry Json",
                shareWithParty: "Condividi con il gruppo",
                regenerateIllustration: "Rigenera illustrazione",
                modifyContent: "Modifica contenuto",
                deleteContent: "Elimina",
                statBlock: "Blocco Statistiche",
                removeBackground: "Rimuovi Sfondo",
            },
            creatureGenerator: {
                title: "Genera Creatura",
                descriptionPrompt: "Descrizione (Sii Creativo)",
                artStyle: "Stile Artistico",
                edition: "Edizione",
                challengeRating: "Livello di Sfida",
                challengeRatingWithValue: "Valutazione della Sfida {challengeRating}",
                waitTime: "Aspetta {time}s",
                generate: "Genera",
                language: 'Lingua',
                placeholders: {
                    influence: "Descrivi la creatura.",
                    edition: "Seleziona un'edizione",
                    style: "Scuro/Gruzzo",
                },
            },
            styles: {
                darkFantasy: "Fantasia Oscura",
                highFantasy: "Alta Fantasia",
                sketch: "Schizzo",
                etherealDream: "Sogno Etereo",
                realism: "Realismo",
                pixelArt: "Pixel Art",
                graphicNovel: "Romanzo Grafico",
                conceptArt: "Arte Concettuale",
            }
        }
    },
    nl: {
        forms: {
            energyConfirmation: {
                requires: "Vereist {energyCost} ENERGIE. Resterend {currentEnergy}. Bekijk abonnementsopties voor extra energie.",
                willConsume: "Zal {energyCost} van {currentEnergy} energie verbruiken.",
                close: "Sluiten",
                cancel: "Annuleren",
                confirm: "Bevestigen"
            },
            optionsMenu: {
                metadata: "Metadata",
                fork: "Afsplitsen",
                foundryJson: "Foundry Json",
                shareWithParty: "Delen met de groep",
                regenerateIllustration: "Illustratie regenereren",
                modifyContent: "Inhoud wijzigen",
                deleteContent: "Verwijderen",
                statBlock: "Statistiekenblok",
                removeBackground: "Achtergrond Verwijderen",
            },
            creatureGenerator: {
                title: "Creëer Wezen",
                descriptionPrompt: "Beschrijving (Wees Creatief)",
                artStyle: "Kunststijl",
                edition: "Editie",
                challengeRating: "Uitdaging Waardering",
                challengeRatingWithValue: "Uitdagingswaardering {challengeRating}",
                waitTime: "Wacht {time}s",
                generate: "Genereren",
                language: 'Taal',
                placeholders: {
                    influence: "Beschrijf het wezen.",
                    edition: "Selecteer een editie",
                    style: "Donker/Grof",
                },
            },
            styles: {
                darkFantasy: "Donkere Fantasie",
                highFantasy: "Hoge Fantasie",
                sketch: "Schets",
                etherealDream: "Etherische Droom",
                realism: "Realisme",
                pixelArt: "Pixel Kunst",
                graphicNovel: "Grafische Roman",
                conceptArt: "Concept Kunst",
            }
        }
    },
    zh: {
        forms: {
            energyConfirmation: {
                requires: "需要 {energyCost} 能量。 剩余 {currentEnergy}。查看更多订阅选项以获取额外能量。",
                willConsume: "将消耗 {currentEnergy} 中的 {energyCost} 能量。",
                close: "关闭",
                cancel: "取消",
                confirm: "确认"
            },
            optionsMenu: {
                metadata: "元数据",
                fork: "复制",
                foundryJson: "Foundry Json",
                shareWithParty: "与队伍分享",
                regenerateIllustration: "重新生成插图",
                modifyContent: "修改内容",
                deleteContent: "删除",
                statBlock: "属性表",
                removeBackground: "移除背景",
            },
            creatureGenerator: {
                title: "生成生物",
                descriptionPrompt: "描述 (发挥创意)",
                artStyle: "艺术风格",
                edition: "版本",
                challengeRating: "挑战评级",
                challengeRatingWithValue: "挑战等级 {challengeRating}",
                waitTime: "等待 {time}秒",
                generate: "生成",
                language: '语言',
                placeholders: {
                    influence: "描述生物。",
                    edition: "选择版本",
                    style: "暗/粗糙",
                },
            },
            styles: {
                darkFantasy: "黑暗奇幻",
                highFantasy: "高级奇幻",
                sketch: "草图",
                etherealDream: "空灵之梦",
                realism: "现实主义",
                pixelArt: "像素艺术",
                graphicNovel: "图像小说",
                conceptArt: "概念艺术",
            }
        }
    },
    ja: {
        forms: {
            energyConfirmation: {
                requires: "{energyCost} エネルギーが必要です。 残り {currentEnergy}。追加のエネルギーのためのサブスクリプションオプションを確認してください。",
                willConsume: "{currentEnergy} の中で {energyCost} エネルギーを消費します。",
                close: "閉じる",
                cancel: "キャンセル",
                confirm: "確認"
            },
            optionsMenu: {
                metadata: "メタデータ",
                fork: "フォーク",
                foundryJson: "Foundry Json",
                shareWithParty: "パーティーと共有する",
                regenerateIllustration: "イラストを再生成",
                modifyContent: "コンテンツを変更する",
                deleteContent: "削除する",
                statBlock: "ステータスブロック",
                removeBackground: "背景を削除",
            },
            creatureGenerator: {
                title: "クリーチャーを生成",
                descriptionPrompt: "説明 (クリエイティブに)",
                artStyle: "アートスタイル",
                edition: "エディション",
                challengeRating: "チャレンジ評価",
                challengeRatingWithValue: "チャレンジ レーティング {challengeRating}",
                waitTime: "{time}秒待つ",
                generate: "生成",
                language: '言語',
                placeholders: {
                    influence: "クリーチャーを説明してください。",
                    edition: "エディションを選択",
                    style: "ダーク/グリッティ",
                },
            },
            styles: {
                darkFantasy: "ダークファンタジー",
                highFantasy: "ハイファンタジー",
                sketch: "スケッチ",
                etherealDream: "エーテリアルドリーム",
                realism: "リアリズム",
                pixelArt: "ピクセルアート",
                graphicNovel: "グラフィックノベル",
                conceptArt: "コンセプトアート",
            }
        }
    },
    ru: {
        forms: {
            energyConfirmation: {
                requires: "Требуется {energyCost} ЭНЕРГИИ. Осталось {currentEnergy}. Подпишитесь для дополнительной энергии.",
                willConsume: "Будет потрачено {energyCost} из {currentEnergy} энергии.",
                close: "Закрыть",
                cancel: "Отменить",
                confirm: "Подтвердить"
            },
            optionsMenu: {
                metadata: "Метаданные",
                fork: "Раздвоить",
                foundryJson: "Foundry Json",
                shareWithParty: "Поделиться с группой",
                regenerateIllustration: "Пересоздать иллюстрацию",
                modifyContent: "Изменить содержание",
                deleteContent: "Удалить",
                statBlock: "Блок Характеристик",
                removeBackground: "Удалить Фон",
            },
            creatureGenerator: {
                title: "Создать Существо",
                descriptionPrompt: "Описание (Будьте Креативными)",
                artStyle: "Арт Стиль",
                edition: "Издание",
                challengeRating: "Оценка Сложности",
                challengeRatingWithValue: "Рейтинг Вызова {challengeRating}",
                waitTime: "Подождите {time}с",
                generate: "Создать",
                language: 'Язык',
                placeholders: {
                    influence: "Опишите существо.",
                    edition: "Выберите издание",
                    style: "Темный/Грубый",
                },
            },
            styles: {
                darkFantasy: "Темное Фэнтези",
                highFantasy: "Высокое Фэнтези",
                sketch: "Эскиз",
                etherealDream: "Эфирный Сон",
                realism: "Реализм",
                pixelArt: "Пиксельное Искусство",
                graphicNovel: "Графический Роман",
                conceptArt: "Концептуальное Искусство",
            }
        }
    },
}
